import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  chartContainer: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
  chartHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  chartSelect: {
    flexGrow: 0,
    flexShrink: 0,
    width: 100,
  },
  chartSubheader: {
    paddingBottom: tokens.spacing[6],
  },
  chart: {
    flexGrow: 1,
    width: "100%",
    height: "100%",
    "& .recharts-cartesian-grid line": {
      stroke: `${tokens.color.semantic.border.faint}`,
    },
    "& .recharts-cartesian-axis-tick-line": {
      stroke: `${tokens.color.semantic.border.faint}`,
    },
    "& .recharts-cartesian-axis-tick-value": {
      fill: `${tokens.color.semantic.text.bold}`,
      fontSize: tokens.font.size.xs,
      lineHeight: tokens.font.lineHeight.snug,
    },
  },
  sandboxOverlay: {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    color: tokens.color.semantic.text.subtle,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacing[2],
    textAlign: "center",
    padding: tokens.spacing[6],
  },
}));
